package api.dataclasses.inbound

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class InboundReceipt(
    @SerialName("RecordId") val recordId: Int,
    @SerialName("Eigenaar") val owner: String,
    @SerialName("Naam") val name: String,
    @SerialName("Statusomschrijving") val statusDescription: String,
    @SerialName("Referentie intern") val internalReference: String,
    @SerialName("Te Ontvangen Aantal") val amountToReceive: Double?,
    @SerialName("Aantal Ontvangen") val amountReceived: Double?
)
